MicroModal.init({
  awaitCloseAnimation: true,
});

const btnModal = document.querySelectorAll(".trigger-modal-recommendation");
const isBtnExists = btnModal && btnModal != null;

// const predictive_search_url =
//   window.MinimogSettings.routes.predictive_search_url;
const predictive_search_url = "/search/suggest";

if (isBtnExists) {
  btnModal.forEach(function (btn) {
    btn.addEventListener("click", async function (element) {
      const button = element.target;
      const query = button.dataset.query != "" ? button.dataset.query : "";
      const target = button.dataset.modal;

      if (query == "") return;

      const currentModal = document.getElementById(target);
      const searchResultContainer = currentModal.querySelector(
        ".modal-search-result"
      );
      const modalLoader = currentModal.querySelector(".modal-loader");

      const searchTerm = query.replace(" ", "-").toLowerCase();
      const searchField =
        "title,product_type,vendor,variants.sku,variants.title";

      MicroModal.show(target, {
        onClose: function (modal) {
          if (modal.classList.contains("modal-recommendation")) {
            const searchResultContainer = modal.querySelector(
              ".modal-search-result"
            );
            const modalLoader = modal.querySelector(".modal-loader");

            modalLoader.classList.remove("hide");
            searchResultContainer.innerHTML = "";
          }
        },
      });

      let searchURL =
        predictive_search_url +
        "?q=" +
        encodeURIComponent(searchTerm) +
        "&resources[limit]=8&resources[type]=product&resources[options][unavailable_products]=last&resources[options][fields]=" +
        searchField +
        "&section_id=predictive-search";

      let resultURL =
        "/search?q=" +
        encodeURIComponent(searchTerm) +
        "&resources[type]=product&resources[options][unavailable_products]=last&resources[options][fields]=" +
        searchField;

      fetch(searchURL)
        .then(function (response) {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
          return response.text();
        })
        .then(function (text) {
          modalLoader.classList.add("hide");
          const resultsMarkup = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#shopify-section-predictive-search").innerHTML;

          let moreButton = '<div class="cm-primary-modal-close">';
          // moreButton +=
          //   '<a href="' +
          //   resultURL +
          //   '" class="sf__btn sf__btn-primary">More Result</a>';
          moreButton +=
            '<a href="#" class="btn btn--large caps btn--primary" data-micromodal-close>Close</a>';
          moreButton += "</div>";

          searchResultContainer.innerHTML = resultsMarkup;
          searchResultContainer.innerHTML += moreButton;
        });
    });
  });
}
